import { useTranslation } from 'react-i18next';

import { Card } from '../../components/Card';

export function ExpiredState() {
  const { t } = useTranslation();
  return (
    <Card>
      <div className="state-icon warning" aria-hidden="true">
        !
      </div>
      <h1>{t('expired.title')}</h1>
      <p>{t('expired.body')}</p>
    </Card>
  );
}
